import PropTypes from 'prop-types';
import React from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import styled from 'styled-components';
import { Colours } from '../../fuse-colours/src/colours';
import * as logos from './logos/index';

const propTypes = {
	alt: PropTypes.string,
	brand: PropTypes.oneOf([
		'LittlewoodsRound',
		'LittlewoodsRoundBasic',
		'LittlewoodsRoundWhite',
		'LittlewoodsStrip',
		'LittlewoodsStripWhite',
		'TakeThree',
		'TakeThreeWhite',
		'TakeThreeStacked',
		'VeryPay',
		'VeryPayBoxPinkV1',
		'VeryPayBoxWhiteV1',
		'VeryPayWhite',
		'VeryPrimary',
		'ParcelconnectRed',
		'ParcelconnectWhite',
	]),
	dataTestId: PropTypes.string,
	href: PropTypes.string,
};
const defaultProps = {
	alt: 'Very Primary logo',
	brand: 'VeryPrimary',
	dataTestId: null,
	href: undefined,
};

const StyledBrandLink = styled.a`
	${({ width }) => {
		// Check if width is passed as number only or as px or % value
		const linkWidth = /[a-zA-Z%]/.test(width) ? width : `${width}px`;

		return `
            display: inline-flex;
            height: auto;
            max-width: 100%;
            position: relative;
            width: ${width ? linkWidth : `100%`};

            &:active,
            &:focus {
                outline: 2px solid ${Colours.functional.focus};
                outline-offset: 0;
            }

            img {
                width: 100%;
                height: 100%;
            }

            /* The below inserts minimum tabbable area to the image */
            &:before {
				content: '';
				display: block;
				min-height: 44px;
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				min-width: 44px;
				width: 100%;
			}
        `;
	}}
`;

function BrandLogos({ alt, brand, dataTestId, href, ...props }) {
	const CurrentLogo = logos[brand];

	return (
		<>
			{href && (
				<StyledBrandLink
					className="fuse-brand-logos"
					data-testid={dataTestId}
					href={href}
					{...props}
				>
					<img
						className="fuse-brand-logos__image"
						alt={alt}
						src={`data:image/svg+xml,${encodeURIComponent(renderToStaticMarkup(<CurrentLogo />))}`}
					/>
				</StyledBrandLink>
			)}
			{!href && (
				<img
					className="fuse-brand-logos fuse-brand-logos__image"
					alt={alt}
					data-testid={dataTestId}
					src={`data:image/svg+xml,${encodeURIComponent(renderToStaticMarkup(<CurrentLogo />))}`}
					{...props}
				/>
			)}
		</>
	);
}

BrandLogos.propTypes = propTypes;
BrandLogos.defaultProps = defaultProps;

export { BrandLogos, logos };

export default BrandLogos;
